import { RG_TYPE, GetAllJoints, deepFlatChildren } from "@project-rouge/rg-core";
import { V3toVector3, getPivot, addOpeningOnClosestPoint, applyInverseTransform } from "@project-rouge/rg-three";
function addOpeningsBetweenCorridors(building, size = [1.5, 2.04, 0.13]) {
  const allCorridors = building.children.filter((c) => c.type === RG_TYPE.Corridor);
  const allJoints = GetAllJoints(building.data.anatomy);
  for (const joint of allJoints) {
    if (joint.bones.length !== 2)
      continue;
    const jointVec = V3toVector3(joint.pos);
    const boneADist = Math.min(V3toVector3(joint.bones[0].tendon.points[0]).distanceToSquared(jointVec), V3toVector3(joint.bones[0].tendon.points[1]).distanceToSquared(jointVec));
    const boneBDist = Math.min(V3toVector3(joint.bones[1].tendon.points[0]).distanceToSquared(jointVec), V3toVector3(joint.bones[1].tendon.points[1]).distanceToSquared(jointVec));
    const closestBone = boneADist < boneBDist ? 0 : 1;
    const tendon = joint.bones[closestBone].tendon;
    const otherTendon = joint.bones[1 - closestBone].tendon;
    const corridors = allCorridors.filter((c) => c.data.tendonID === tendon.id);
    const otherCorridors = allCorridors.filter((c) => c.data.tendonID === otherTendon.id);
    for (const corridor of corridors) {
      const floorHeight = Math.max(...deepFlatChildren(corridor).filter((c) => c.type === RG_TYPE.Floor).map((f) => f.pos[1]));
      const heightPivot = (floorHeight + corridor.anchor[1] * corridor.size[1]) / corridor.size[1];
      const otherCorridor = otherCorridors.find((c) => c.data.level === corridor.data.level);
      if (otherCorridor) {
        const start = getPivot([0, heightPivot, 0.5], corridor);
        const end = getPivot([1, heightPivot, 0.5], corridor);
        const refPoint = start.distanceToSquared(jointVec) < end.distanceToSquared(jointVec) ? start : end;
        addOpeningOnClosestPoint({ obj: corridor, point: applyInverseTransform(refPoint, corridor), type: RG_TYPE.Opening, size });
        addOpeningOnClosestPoint({ obj: otherCorridor, point: applyInverseTransform(refPoint, otherCorridor), type: RG_TYPE.Opening, size });
      }
    }
  }
}
export {
  addOpeningsBetweenCorridors
};
//# sourceMappingURL=index30.js.map
